import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import { RecordMapper } from '@/bundles/App/models/RecordMapper';
import { IBaseModel } from '@/bundles/App/interfaces/IBaseModel';
import { AppService } from '@/bundles/App/models/AppService';

export abstract class BaseService<TEntity extends IBaseModel, TMapper extends RecordMapper<TEntity>> extends AppService {
  protected readonly recordMapper: TMapper;

  constructor (transport: HttpTransport, errorMapper: ErrorMapper, recordMapper: TMapper) {
    super(transport, errorMapper);
    this.recordMapper = recordMapper;
  }
}
